import { useTranslation } from "react-i18next";
import { GridOptions } from "ag-grid-community/dist/types/src/entities/gridOptions";
import { SalaryTypeSupplementMappingJSON } from "@hr/api/model";
import { ICellRendererParams, ValueFormatterParams } from "ag-grid-enterprise";
import { SalaryTypeCodeRenderer } from "@hr/organizationview/integrations/modals/SettingsProcountor/SalaryTypeCodeRenderer.tsx";
import { usePayTypeOptions } from "../hooks/useGetAbsenceMappingOptions.js";

export const useGetColumnsForBenefitMapping = (integration: string): GridOptions<SalaryTypeSupplementMappingJSON>["columnDefs"] => {
  const { t } = useTranslation();
  const salaryTypeOptionsForSelect = usePayTypeOptions(integration, "FULL"); // fetch pay type options based on integration
  const mappingEditValues = salaryTypeOptionsForSelect?.map(({ value }) => value);

  const salaryTypeCodeRenderer = (params: ICellRendererParams) => {
    if (!params.value) {
      return "";
    }
    const label = salaryTypeOptionsForSelect?.find((option) => option.value.toString() === params.value.toString());

    return <span style={{ maxHeight: "80%" }}>{label ? label.label : params.value}</span>;
  };

  return [
    {
      headerName: t("SalarySupplement"),
      field: "supplement",
      editable: false,
    },
    {
      headerName: t("SupplementName"),
      field: "supplementName",
      editable: (params) => !params.data?.locked,
      cellEditor: "agTextCellEditor",
      singleClickEdit: true,
      filter: "agTextColumnFilter",
    },
    {
      headerName: t("SalaryType"),
      field: "salaryTypeCode",
      editable: (params) => !params.data?.locked,
      cellRenderer: SalaryTypeCodeRenderer(integration), // pass integration to renderer
      cellEditor: "agRichSelectCellEditor",
      singleClickEdit: true,
      cellEditorParams: {
        values: mappingEditValues,
        cellRenderer: (params: ICellRendererParams) => salaryTypeCodeRenderer(params),
      },
      filter: "agSetColumnFilter",
      filterParams: {
        values: mappingEditValues,
        valueFormatter: (params: ValueFormatterParams) => {
          const label = salaryTypeOptionsForSelect?.find(
            (option) => option.value.toString() === params.value.toString(),
          );
          return label ? label.label : params.value;
        },
      },
    },
  ];
};
